<script setup lang="ts">

</script>

<template>
  <div></div>
  <!-- <ElBacktop
    :class="prefixCls"
    :target="`.${variables.namespace}-layout-content-scrollbar .${variables.elNamespace}-scrollbar__wrap`"
  /> -->
</template>
